import React, { forwardRef, useEffect, useState } from "react";

import { getOrderDocuments } from "@egovernments/digit-ui-module-obps/src/utils";
import { Accordion, AccordionDetails, AccordionSummary, Card, styled, TableCell, tableCellClasses, TableRow } from "@mui/material";

// import DocumentsPreview from "../../obps/src/components/DocumentsPreview";
import { Avatar } from "@material-ui/core";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import BPADocumentsPreview from "../ApplicationDetails/components/BPADocumentsPreview";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useDepartmentSelector from "@egovernments/digit-ui-module-obps/src/pages/citizen/TCPForms/hooks/useDepartmentSelector";
import { questions } from "@egovernments/digit-ui-module-obps/src/components/LandUseNOC/constant";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";

const ApplicaionFormatView = forwardRef(({ formData, applicationDocs, logoData }, ref) => {
  const history = useHistory();
  const [logoUrl, setLogoUrl] = useState("");
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [, applicationFlow] = useDepartmentSelector();
  const { t } = useTranslation();
  const isEmployee = history.location.pathname.includes("employee");
  const user = Digit.UserService.getUser();
  const isLowRiskCase = formData?.riskType === "LOW";
  // const currentLogoId = logoData?.boundary?.find((item) => item.name === formData?.location1)?.fileStoreId;

  // console.log({ currentLogoId }, formData?.location1, "logoCalculation");
  const currentLogoId = logoData?.boundary?.find((item) => item.name === formData?.location1)?.fileStoreId;
  const fetchLogoUrl = async () => {
    if (!currentLogoId) return;
    const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
    setLogoUrl(result);
  };
  //formData?.descriptionOfLand.schemeType === "Scheme" &&
  //formData?.descriptionOfLand?.landUsesType === "Residential" &&
  // formData?.descriptionOfLand?.subLandUseAsPerLayout === "Residential" &&
  //formData?.descriptionOfLand?.landArea <= 2000;
  let nameOfDepartment;
  const isDA = formData?.department === "DA";
  if (isEmployee) {
    nameOfDepartment = user?.info?.tenantId == "up.da" ? `${formData?.location1?.toUpperCase()} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  } else {
    nameOfDepartment = applicationFlow === "DA" ? `${formData?.location1.toUpperCase()} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  }
  const descriptionOfLand = formData?.descriptionOfLand;
  const owners = formData?.landInfo?.owners;
  const roadWidths = descriptionOfLand?.roadWidths;
  const khasraDetails = descriptionOfLand?.khasraDetails;
  const multipleKhasra = descriptionOfLand?.multipleKhasra;
  const otherSides = descriptionOfLand?.otherSides;
  const approachRoadWidths = descriptionOfLand?.approachRoadWidths;
  console.log(formData, "FromSUmmary");
  const nocApplicantData = formData?.nocDetails?.applicantNOCData;
  const selectedNOCs = console.log(nocApplicantData, "nocapplicant");
  const additionalNOC = formData?.nocDetails?.additionalApplicantNOC;
  console.log("additionalNocs", additionalNOC);
  const isSchemeType = formData?.descriptionOfLand?.schemeType === "Scheme";
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));
  const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const accordionSummaryStyles = {
    backgroundColor: "rgb(230, 239, 248)",
    height: "1rem",
    minHeight: "48px",
    "&.Mui-expanded": {
      backgroundColor: "rgb(230, 239, 248)", // Override the background for expanded state
      minHeight: "48px", // Ensure minHeight is applied in expanded state
      height: "1rem", // Apply the custom height in expanded state as well
    },
  };
  const filteredDocuments = applicationDocs.filter((doc) => !["applicantPhoto", "signature"].includes(doc.documentType)); // removing photo and signature from documents
  useEffect(() => {
    fetchLogoUrl();
  }, [logoData, formData]);
  return (
    <React.Fragment>
      <div
        style={{
          backgroundColor: "#ffffff",
        }}
        ref={ref}
      >
        <div style={{ display: "flex", padding: "5px", background: "rgb(230, 239, 248)" }}>
          <div style={{ background: "white", borderRadius: "50%" }}>
            <img width="60" height="30" src={logoUrl} alt="Uttar-Pradesh-Logo" />
          </div>
          <div style={{ color: "#1f4a7c" }}>
            <p style={{ marginLeft: "12px", fontSize: "1.25rem", fontWeight: "600", fontFamily: "Montserrat" }}>{nameOfDepartment}</p>
            <p style={{ marginLeft: "12px", fontFamily: "Montserrat", fontWeight: "500" }}>Government of Uttar Pradesh</p>
          </div>
        </div>

        <div className="container1" style={{ width: "100%", marginTop: "1rem" }}>
          {/* <div className="formContainer " style={{ height: "48px", background: "rgb(230, 239, 248) ", borderRadius: "1px" }}>
            <div className="formHeaderContainer">
              <h2 className="formHeading">Land Use Verification</h2>
            </div>
          </div> */}

          {/* <Card style={{ backgroundColor: "#eeeab5b0", padding: "20px" }}>
            <b>Land Use Verification Services</b> for Town Planners/Architects/Engineers, property tax payment, and trade licenses, building plan
            approvals etc. It aims to simplify local government processes, providing easy access to urban residents.
          </Card> */}
          {formData?.land_Id && (
            <Card className="formContainer">
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                  <div className="formHeaderContainer">
                    <h2 className="formHeading">Land Id</h2>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="formInputContainer">
                    <div>
                      {" "}
                      <b>FASTPAS ID : </b>
                      <span style={{ marginLeft: "1rem" }}>{formData?.land_Id}</span>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </Card>
          )}
          {/* Selected Authority */}

          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">Verifying Authority</h2>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                {isDA ? (
                  <div className="formInputContainer">
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <td style={{ width: "20%", textAlign: "left", padding: "8px" }}>
                          <b>Selected Office : </b>
                        </td>
                        <td style={{ width: "20%", padding: "8px" }}>{formData?.selectedOffice}</td>
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                    <div style={{ width: "100%" }}>
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                          {formData?.selectedUnit && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Selected Unit:</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{formData.selectedUnit}</td>
                            </tr>
                          )}
                          {formData?.selectedCity && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Selected City:</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{formData.selectedCity}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </AccordionDetails>
            </Accordion>
          </Card>
          {/* Applicant Information */}
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">Owner Information</h2>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "100%" }}>
                    <div>
                      {owners?.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            marginTop: "15px",
                            marginBottom: "15px",

                            paddingBottom: "15px",
                          }}
                        >
                          {/*  */}
                          <div style={{ flex: "1 1 calc(50% - 10px)", marginRight: "10px" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                              <tbody>
                                {item?.name && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>Name :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{item?.name}</td>
                                  </tr>
                                )}
                                {item?.fatherOrHusbandName && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>Father Name :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{item?.fatherOrHusbandName}</td>
                                  </tr>
                                )}
                                {item?.mobileNumber && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>Mobile Number :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{item?.mobileNumber}</td>
                                  </tr>
                                )}
                                {item?.aadhaarNumber && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>Aadhaar Number :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{item?.aadhaarNumber}</td>
                                  </tr>
                                )}
                                {formData?.applicationNo && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>Application Number :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{formData?.applicationNo}</td>
                                  </tr>
                                )}
                                {item?.gender && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>Gender :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{item?.gender}</td>
                                  </tr>
                                )}
                                {item?.emailId && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>E-mail ID :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{item?.emailId}</td>
                                  </tr>
                                )}
                                {item?.correspondenceAddress?.state && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>State :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{item?.correspondenceAddress?.state}</td>
                                  </tr>
                                )}
                                {item?.address && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>Address :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{item?.address}</td>
                                  </tr>
                                )}
                                {item?.correspondenceAddress?.pinno && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>Pin Code :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{item?.correspondenceAddress?.pinno}</td>
                                  </tr>
                                )}
                                {item?.correspondenceAddress?.town && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>District :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{item?.correspondenceAddress?.town}</td>
                                  </tr>
                                )}
                                {item?.statusType && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>Applicant Status :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{item?.statusType}</td>
                                  </tr>
                                )}
                                {item?.remarks && (
                                  <tr>
                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                      <b>Remarks :</b>
                                    </td>
                                    <td style={{ padding: "8px" }}>{item?.remarks}</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          {item?.photo && (
                            <div
                              style={{
                                flex: "1 1 calc(50% - 10px)",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-around",
                                alignItems: "center",
                                padding: "24px",
                              }}
                            >
                              <div className="row" style={{ marginBottom: "10px" }}>
                                {item?.photo ? (
                                  <img
                                    style={{ width: "200px", height: "180px", objectFit: "cover" }}
                                    src={item?.photo}
                                    alt={"image"}
                                    className="img-thumbnail"
                                  />
                                ) : (
                                  <Avatar style={{ width: "200px", height: "80px" }}>{item?.photo}</Avatar>
                                )}
                              </div>
                              <div className="row" style={{ marginBottom: "10px", marginTop: "80px" }}>
                                {item?.signature ? (
                                  <img style={{ width: "200px", height: "80px" }} src={item?.signature} alt={"signature"} className="img-thumbnail" />
                                ) : (
                                  <BorderColorIcon style={{ width: "70px", height: "25px" }}>{item?.signature}</BorderColorIcon>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">Licensed Technical Professional (LTP) Information</h2>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "100%" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        {formData?.professionalInformation?.consultantCategory && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Consultant Category :</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData.professionalInformation.consultantCategory}</td>
                          </tr>
                        )}
                        {formData?.professionalInformation?.name && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Name :</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData.professionalInformation.name}</td>
                          </tr>
                        )}
                        {formData?.professionalInformation?.planDate && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Validity :</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData.professionalInformation.planDate}</td>
                          </tr>
                        )}
                        {formData?.professionalInformation?.mobileNumber && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Mobile No. :</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData.professionalInformation.mobileNumber}</td>
                          </tr>
                        )}
                        {formData?.professionalInformation?.certificateNumber && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Certificate No. :</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData.professionalInformation.certificateNumber}</td>
                          </tr>
                        )}
                        {formData?.professionalInformation?.licenseNumber && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>License No :</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData.professionalInformation.licenseNumber}</td>
                          </tr>
                        )}
                        {formData?.professionalInformation?.emailId && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>E-mail Id :</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData.professionalInformation.emailId}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">Land Information</h2>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ margin: "0px 4px", display: "flex", justifyContent: "center" }}>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      {formData?.descriptionOfLand?.schemeType && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Scheme Type :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.schemeType || ""}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.planOn && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Plan on :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.planOn || ""}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.schemeName && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Scheme Name :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.schemeName || ""}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.sectorNo && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Sector No. :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.sectorNo || ""}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.developmentArea && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Development Area :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.developmentArea || ""}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.activityAsPerMap && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Primary Use of Proposed Activity :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.activityAsPerMap || ""}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.activityProposed && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Activity Proposed :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.activityProposed || ""}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.selectLandUse && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Permissibility of Activities :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.selectLandUse || ""}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.proposedActivity && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Proposed Activity as per Zoning Regulation :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.proposedActivity || ""}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.landUsesType && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>
                              {formData?.descriptionOfLand?.schemeType === "Scheme"
                                ? "Land Use as per Layout Plan :"
                                : "Land Use as per Master Plan :"}
                            </b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.landUsesType || ""}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.subLandUseAsPerLayout && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>
                              {formData?.descriptionOfLand?.schemeType === "Scheme"
                                ? "Land Sub Use as per Layout :"
                                : "Land Use as per Master Plan :"}
                            </b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.subLandUseAsPerLayout || ""}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.otherMasterPlan && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Other Master Layout Plan :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.otherMasterPlan || ""}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.selectLandUse && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Permissibility of Activities :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.selectLandUse || ""}</td>
                        </tr>
                      )}

                      {/* {multipleKhasra?.length > 0 &&
                        multipleKhasra.map((khasra, index) => (
                          <React.Fragment>
                            <tr key={index}>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Khasra/Arazi No :</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{khasra.khasraNo || ""}</td>
                            </tr>
                            <tr key={index}>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Area :</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{khasra.area || ""}</td>
                            </tr>
                          </React.Fragment>
                        ))} */}
                      {/* {multipleKhasra?.length > 0 &&
                        multipleKhasra.map((khasra, index) => (
                          <tr key={index}>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Area :</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{khasra.area || ""}</td>
                          </tr>
                        ))} */}
                      {descriptionOfLand?.blockNo && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Block No./Name :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.blockNo || ""}</td>
                        </tr>
                      )}
                      {formData?.landInfo?.owners?.[0]?.permanentAddress?.district && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("LABEL_DISTRICT")} :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.landInfo?.owners?.[0]?.permanentAddress?.district || ""}</td>
                        </tr>
                      )}
                      {/* {formData?.landInfo?.owners?.[0]?.permanentAddress?.tehsil && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Tehsil")} :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.landInfo?.owners?.[0]?.permanentAddress?.tehsil || ""}</td>
                        </tr>
                      )}
                      {formData?.landInfo?.owners?.[0]?.permanentAddress?.village && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Village")} :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.landInfo?.owners?.[0]?.permanentAddress?.village || ""}</td>
                        </tr>
                      )} */}
                      {descriptionOfLand?.plotFront && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Front Width (M) :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.plotFront || ""}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.plotRear && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Rear Width (M) :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.plotRear || ""}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.plotSide1 && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Side Width 1 :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.plotSide1 || ""}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.plotSide2 && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Side Width 2 :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.plotSide2 || ""}</td>
                        </tr>
                      )}
                      {/* {otherSides?.length > 0 &&
                        otherSides.map((otherSide, index) => (
                          <tr key={index}>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Other Side :</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{otherSide.value || ""}</td>
                          </tr>
                        ))} */}
                      {descriptionOfLand?.khatauniNo && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Khatauni No. :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.khatauniNo || ""}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.khataNo && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Khata No. :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.khataNo || ""}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.plotNo && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Plot No. :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.plotNo || ""}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.landWidth && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Land Width :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.landWidth || ""}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.landLength && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Land Length :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.landLength || ""}</td>
                        </tr>
                      )}
                      {khasraDetails?.length > 0 &&
                        !isSchemeType &&
                        khasraDetails.map((item, index) => (
                          <React.Fragment key={index}>
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>District {index + 1} :</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{item.district || ""}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Tehsil {index + 1} :</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{item.tehsil || ""}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Village {index + 1} :</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{item.village || ""}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Plot No. {index + 1} :</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{item.plotNo || ""}</td>
                            </tr>
                            {/* Optional: Add a horizontal line between entries */}
                            {/* <tr>
                              <td colSpan="2">
                                <hr />
                              </td>
                            </tr> */}
                          </React.Fragment>
                        ))}

                      {formData?.descriptionOfLand?.plotAreaDoc && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Plot Area (as per document) (sq. m) :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.plotAreaDoc}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.landArea && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Plot Area (as per site) (sq. m) :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.landArea}</td>
                        </tr>
                      )}
                      {formData?.descriptionOfLand?.plotAreaPossession && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Plot Area (as per possession) (sq. m) :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.plotAreaPossession}</td>
                        </tr>
                      )}
                      {roadWidths?.length > 0 &&
                        roadWidths.map((road, index) => (
                          <tr key={index}>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Road Width (Existing) (m) :</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{road.value || ""}</td>
                          </tr>
                        ))}
                      {approachRoadWidths?.length > 0 &&
                        approachRoadWidths.map((road, index) => (
                          <tr key={index}>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Road Width (as per the respective plan) (m) :</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{road.value || ""}</td>
                          </tr>
                        ))}
                      {descriptionOfLand?.landMark && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Nearby Landmark :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.landMark || ""}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.landAddress && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>Land Address :</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.landAddress || ""}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>

          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">Documents Section</h2>{" "}
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer">
                  {
                    <BPADocumentsPreview
                      documents={getOrderDocuments(filteredDocuments)}
                      svgStyles={{}}
                      isSendBackFlow={false}
                      isHrLine={true}
                      titleStyles={{ fontSize: "18px", lineHeight: "24px", fontWeight: 700, marginBottom: "10px" }}
                    />
                  }
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
          {(descriptionOfLand?.latitude || descriptionOfLand?.googleMapLocation) && (
            <Card className="formContainer">
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                  <div className="formHeaderContainer">
                    <h2 className="formHeading">Location Information</h2>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                    <div style={{ width: "100%" }}>
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                          {descriptionOfLand?.latitude && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Map Coordinates:</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>
                                Latitude: {descriptionOfLand?.latitude}, Longitude: {descriptionOfLand?.longitude}
                              </td>
                            </tr>
                          )}
                          {formData?.descriptionOfLand?.googleMapLocation && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Map Location:</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.googleMapLocation}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </Card>
          )}
          {(nocApplicantData || additionalNOC) && !isLowRiskCase && (
            <Card className="formContainer">
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                  <div className="formHeaderContainer">
                    <h2 className="formHeading">{t("BPA_MY_APPLICATIONS_LANDUSENOC")}</h2>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                    <div style={{ width: "100%" }}>
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                          {questions
                            .filter((questionItem) => nocApplicantData[questionItem.applicantName] === true) // Filter for applicant-selected NOCs
                            .map((questionItem, index) => {
                              const { label, applicantName } = questionItem;
                              const answer = nocApplicantData[applicantName] ? "Yes" : "No"; // Determine if selected
                              console.log(
                                "fromMap",
                                answer,
                                label,
                                questions.filter((questionItem) => nocApplicantData[questionItem.applicantName] === true)
                              );

                              return (
                                <tr key={index}>
                                  <td style={{ width: "70%", textAlign: "left", padding: "8px" }}>{label}</td>
                                  <td style={{ width: "30%", textAlign: "center", padding: "8px" }}>{answer}</td>
                                </tr>
                              );
                            })}
                          {additionalNOC?.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td style={{ width: "70%", textAlign: "left", padding: "8px" }}>{item.value}</td>
                                <td style={{ width: "30%", textAlign: "center", padding: "8px" }}>Yes</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </Card>
          )}
          {!(formData?.descriptionOfLand?.schemeType == "Scheme") && (
            <Card className="formContainer">
              {" "}
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                  <div className="formHeaderContainer">
                    <h2 className="formHeading">Processing Fee for Land Use Verification</h2>
                  </div>
                </AccordionSummary>

                <AccordionDetails>
                  <div className="formInputContainer">
                    <div style={{ display: "flex" }}>
                      <b>Total Amount</b>
                      <p style={{ marginLeft: "1rem" }}>
                        <span>₹ {formData?.taxHeadEstimate?.[0]?.estimateAmount}</span>
                      </p>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </Card>
          )}
        </div>
      </div>
    </React.Fragment>
  );
});
export default ApplicaionFormatView;
